// extracted by mini-css-extract-plugin
export default {"cardDetails":"NewSupplier_cardDetails__+SOmh"};